/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Forest_EnergyInputs */

const en_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Forest Energy`)
};

const ar_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} قوة Forest`)
};

const de_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Forest Power`)
};

const es_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} poder de tu bosque`)
};

const fr_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Pouvoir Forest`)
};

const it_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Forest Power`)
};

const ja_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Forestパワー`)
};

const ko_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Forest Power ${i?.number}`)
};

const pt_br_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Poder do Forest`)
};

const ru_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} сила Forest`)
};

const th_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} พลังแห่ง Forest`)
};

const tr_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} Forest Gücü`)
};

const zh_cn_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} 森林能量`)
};

const zh_tw_forest_energy = /** @type {(inputs: Forest_EnergyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.number} 森林能量`)
};

/**
* | output |
* | --- |
* | "{number} Forest Energy" |
*
* @param {Forest_EnergyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const forest_energy = /** @type {((inputs: Forest_EnergyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forest_EnergyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forest_energy(inputs)
	if (locale === "ar") return ar_forest_energy(inputs)
	if (locale === "de") return de_forest_energy(inputs)
	if (locale === "es") return es_forest_energy(inputs)
	if (locale === "fr") return fr_forest_energy(inputs)
	if (locale === "it") return it_forest_energy(inputs)
	if (locale === "ja") return ja_forest_energy(inputs)
	if (locale === "ko") return ko_forest_energy(inputs)
	if (locale === "pt_br") return pt_br_forest_energy(inputs)
	if (locale === "ru") return ru_forest_energy(inputs)
	if (locale === "th") return th_forest_energy(inputs)
	if (locale === "tr") return tr_forest_energy(inputs)
	if (locale === "zh_cn") return zh_cn_forest_energy(inputs)
	return zh_tw_forest_energy(inputs)
});